export default [
  {
    title: 'Cliente SalesFlow',
    icon: 'UserIcon',
    action: 'read',
    resource: 'MenuClienteDKP',
    children: [
      {
        title: 'Clientes',
        route: 'clientes-dkṕ-list',
        icon: 'UserIcon',
        action: 'read',
        resource: 'ClienteDKP',
      },
      {
        title: 'Cliente Token',
        route: 'dkp-clientes-tokens-list',
        icon: 'UserIcon',
        action: 'read',
        resource: 'TokenClienteDKP',
      },
    ],
  },
];
